<template>
    <div class="mcc-card">
        <div class="mcc-card__body">
            <div class="mu-d-flex mu-gap-03 mu-w-100 overflow-auto">
                <div class="mu-d-flex mu-flex-column mu-gap-03 mu-flex-grow-1 fixedWidthContainer">
                    <div class="mfc-label" id="available">Available</div>
                    <div class="mfc-input-wrapper">
                        <label for="list-group-filter" class="mu-visually-hidden">Filter</label>
                        <input id="list-group-filter" name="list-group-filter" type="text" class="" placeholder="Filter..." ref="listGroupFilter">
                    </div>
                    <div class="mu-overflow-hidden mu-flex-grow-1 mu-border mu-border-ui-05 mu-border mu-radius-02" style="min-height: 250px;">
                        <div class="mu-overflow-auto mu-p-03" style="max-block-size: 20rem;">
                            <fieldset class="[ mfc-fieldset ]" aria-labelledby="available" :disabled="disabled">
                                <div class="[ mfc-checkbox-wrapper mfc-choice-button-group ] [ mu-gap-01 ] mcc-list-group">
                                    <label v-for="(item, index) in filteredData" :key="`available-${index}`" :for="`available-${index}`" class="mu-py-03 checkboxMarginStart">
                                        <input :checked="isItemInIntersection(item)" type="checkbox" :id="`available-${index}`" name="mds_checkbox_choice_button1" :value="getItemValue(item)" :disabled="isItemDisabled(item)" @click="leftSelectItem($event)" />
                                        <span class="optionss">{{ getItemText(item) }}</span>
                                    </label>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>
                <div class="mu-d-flex mu-flex-column mu-justify-content-center mu-gap-03">
                    <button class="mcc-button mcc-button--icon-only mcc-button--outline" type="button" @click="moveRight" :disabled="disabled">
                        <mcc-icon name="angle_right" aria-hidden="true" class="mcc-icon"></mcc-icon>
                    </button>
                    <button class="mcc-button mcc-button--icon-only mcc-button--outline" type="button" @click="moveLeft" :disabled="disabled">
                        <mcc-icon name="angle_left" aria-hidden="true" class="mcc-icon"></mcc-icon>
                    </button>
                </div>
                <div class="mu-d-flex mu-flex-column mu-gap-03 mu-flex-grow-1 fixedWidthContainer">
                    <div class="mfc-label" id="selected">Selected</div>
                    <div class="mfc-input-wrapper">
                        <label for="list-group-filters" class="mu-visually-hidden">Search Selected</label>
                        <input id="list-group-filters" name="list-group-filters" type="text" placeholder="Filter..." ref="listGroupFilters">
                    </div>
                    <div class="mu-overflow-hidden mu-flex-grow-1 mu-border mu-border-ui-05 mu-border mu-radius-02" style="min-height: 250px;">
                        <div class="mu-overflow-auto mu-p-03" style="max-block-size: 20rem;">
                            <fieldset class="[ mfc-fieldset ]" aria-labelledby="selected" :disabled="disabled">
                                <div class="[ mfc-checkbox-wrapper mfc-choice-button-group ] [ mu-gap-01 ] mcc-list-group-class">
                                    <label v-for="(item, index) in filteredValue" :key="`selected-${index}`" :for="`selected-${index}`" class="mu-py-03 checkboxMarginStart">
                                        <input :checked="isItemInIntersections(item)" type="checkbox" :id="`selected-${index}`" name="mds_checkbox_choice_button2" :value="getItemValue(item)" :disabled="isItemDisabled(item)" @click="rightSelectItem($event)" />
                                        <span class="optionss">{{ getItemText(item) }}</span>
                                    </label>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Picklist',
    props: {
        msg: String,
        disabled: Boolean,
        handleChange: Function
    },
    data() {
        return {
            value: [],
            data: [],
            leftSelectedItems: [],
            rightSelectedItems: [],
            filterText: '',
            selectedFilterText: '',
            intersection: [],
            rightIntersection: []
        };
    },
    mounted() {
        this.$refs.listGroupFilter.addEventListener('input', (event) => {
            this.filterText = event.target.value.toLowerCase();
        });
        this.$refs.listGroupFilters.addEventListener('input', (event) => {
            this.selectedFilterText = event.target.value.toLowerCase();
        });
    },
    computed: {
        filteredData() {
            this.intersection = [];
            let datas = this.data.filter(item => this.getItemText(item).toLowerCase().includes(this.filterText));
            this.intersection = datas.filter(item => this.leftSelectedItems.some(selectedItem => selectedItem ===  this.getItemText(item)));
            return this.data.filter(item => this.getItemText(item).toLowerCase().includes(this.filterText));
        },
        filteredValue() {
            this.rightIntersection = [];
            let datas = this.value.filter(item => this.getItemText(item).toLowerCase().includes(this.selectedFilterText));
            this.rightIntersection = datas.filter(item => this.rightSelectedItems.some(selectedItem => selectedItem ===  this.getItemText(item)));
            return this.value.filter(item => this.getItemText(item).toLowerCase().includes(this.selectedFilterText));
        }
    },
    methods: {
        isItemInIntersections(item) {
            return this.rightIntersection.some(intersectedItem => this.getItemText(intersectedItem) === this.getItemText(item));
        },
        isItemInIntersection(item) {
            return this.intersection.some(intersectedItem => this.getItemText(intersectedItem) === this.getItemText(item));
        },
        getItemText(item) {
            return typeof item === 'object' && item !== null ? item.text : item;
        },
        getItemValue(item) {
            return this.getItemText(item);
        },
        isItemDisabled(item) {
            return typeof item === 'object' && item !== null && item.disabled;
        },
        setData(data, value) {
            this.data = data.filter(
                (item) => !value.includes(this.getItemValue(item))
            );
            this.value = data.filter(
                (item) => value.includes(this.getItemValue(item))
            );
        },
        moveRight() {
            this.value = [...this.value, ...this.leftSelectedItems];
            this.data = this.data.filter(
                (item) => !this.leftSelectedItems.includes(this.getItemValue(item))
            );
            this.leftSelectedItems.forEach(item => {
                const checkbox = document.querySelector(`input[value="${this.getItemValue(item)}"]`);
                if (checkbox) {
                    checkbox.checked = false;
                }
            });
            if (this.handleChange) {
                this.handleChange('add', this.leftSelectedItems)
            }
            this.leftSelectedItems = [];
        },
        moveLeft() {
            this.data = [...this.data, ...this.rightSelectedItems];
            this.value = this.value.filter(
                (item) => !this.rightSelectedItems.includes(this.getItemValue(item))
            );
            this.rightSelectedItems.forEach(item => {
                const checkbox = document.querySelector(`input[value="${this.getItemValue(item)}"]`);
                if (checkbox) {
                    checkbox.checked = false;
                }
            });
            if (this.handleChange) {
                this.handleChange('remove', this.rightSelectedItems)
            }
            this.rightSelectedItems = [];

        },
        leftSelectItem(e) {
            const value = e.target.value;
            if (e.target.checked) {
                this.leftSelectedItems.push(value);
            } else {
                this.leftSelectedItems = this.leftSelectedItems.filter(
                    (item) => item != value
                );
            }
        },
        rightSelectItem(e) {
            const value = e.target.value;
            if (e.target.checked) {
                this.rightSelectedItems.push(value);
            } else {
                this.rightSelectedItems = this.rightSelectedItems.filter(
                    (item) => item != value
                );
            }
        },
    },
};
</script>

<style scoped>
.fixedWidthContainer {
    width: 300px;
}
.checkboxMarginStart {
    margin-block-start: 8px;
}
</style>
